export const USER_BASIC_START = "USER_BASIC_START";
export const USER_BASIC_SUCCESS = "USER_BASIC_SUCCESS";
export const USER_BASIC_FAIL = "USER_BASIC_FAIL";

export const GENERATE_CSV_KEY_START = "GENERATE_CSV_KEY_START";
export const GENERATE_CSV_KEY_SUCCESS = "GENERATE_CSV_KEY_SUCCESS";
export const GENERATE_CSV_KEY_FAIL = "GENERATE_CSV_KEY_FAIL";
